export const UPDATE_MAIL_TEMPLATE_SUCCESS = 'UPDATE_MAIL_TEMPLATE_SUCCESS';

export const updateMailTemplateSuccess = ({ mailTemplate }) => ({
    type: UPDATE_MAIL_TEMPLATE_SUCCESS,
    payload: {
        mailTemplate,
    },
});
